/* eslint-disable */
import * as icon from 'vue-svgicon'
icon.register({
  'gutachten': {
    width: 48,
    height: 48,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M32.5 17.1h-1.1V16h1.1v1.1zm-3.5 0h-1V16h1v1.1zm-3.4 0h-1.1V16h1.1v1.1zM20 12v6h.4c2.3 0 4 1 4.4 2.6.1.4.1.9.1 1.4h2.6v4.7l4.6-4.7H36V12H20z"/><path pid="1" d="M28 32.8c-.4-1-3.7-2.4-5.5-3.1v-1.4c.6-.5.9-1.6.9-2.4.4-.3.6-.9.6-1.5 0-.4-.1-.9-.5-1.2.3-.7.5-1.6.3-2.3-.3-1.1-1.6-1.9-3.5-1.9-1.2 0-2.7.4-3.3 1.5-.4 0-.8.1-1.1.5-.4.6 0 1.6.3 2.3-.4.3-.6.8-.6 1.3 0 .6.3 1.2.8 1.4 0 .9.3 1.9 1 2.4v1.4c-1.8.7-5 2.2-5.4 3.1v3.2h16v-3-.3"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/gutachten.js